import React, { Component } from 'react';
import LandingPanel from '../../landingPagePanel/landingPagePanel';
import LandingSidebar from '../../landingSidebar/landingSidebar';

const beamSidebarLinks = [
    {label: 'Overview', to: '/distributed-computing/apache-beam'},
];

class BeamLanding extends Component{

    constructor(props){
        super(props);
        this.beamConcepts = [
            {id: 1, title: 'What is Apache Beam?',
                content: 'An introduction to Apache Beam and what it can do.',
                slug:'what-is-apache-beam',
                image: "/images/distributed/beam-landing/what-is-apache-beam.svg",
                enabled: false},
            {id: 2, title: 'Concepts in Apache Beam',
                content: 'The concepts behind Apache Beam',
                slug:'apache-beam-concepts',
                image: "/images/distributed/beam-landing/apache-beam-concepts.svg",
                enabled: false},
            {id: 3, title: 'State in Apache Beam',
                content: 'How Apache Beam handles state',
                slug:'apache-beam-state',
                image: "/images/distributed/beam-landing/apache-beam-state.svg",
                enabled: false},
            {id: 4, title: 'Persistence in Apache Beam',
                content: 'How Apache Beam handles persistence',
                slug: 'apache-beam-persistence',
                image: '/images/distributed/beam-landing/apache-beam-persistence.svg',
                enabled: false}

        ];

        this.beamSimpleExamples = [
            {id: 1, title: 'Word Count',
                content: 'The classic Beam example: counting word occurrences across a text corpus',
                slug:'beam-word-count',
                image: '/images/distributed/beam-landing/word-count.svg',
                enabled: false},
            {id: 2, title: 'Log File Parsing',
                content: 'Parsing and filtering raw server logs into structured records',
                slug:'beam-log-file-parsing',
                image: '/images/distributed/beam-landing/log-file-parsing.svg',
                enabled: false},
            {id: 3, title: 'CSV to BigQuery',
                content: 'A batch pipeline that loads and transforms CSV files into a data warehouse',
                slug:'beam-csv-to-bigquery',
                image: '/images/distributed/beam-landing/csv-to-bigquery.svg',
                enabled: false},
            {id: 4, title: 'Streaming Pub/Sub Ingestion',
                content: 'Ingesting and transforming a live Pub/Sub stream into BigQuery',
                slug: 'beam-pubsub-streaming',
                image: '/images/distributed/beam-landing/pubsub-streaming.svg',
                enabled: false},

        ];

        this.tutorials = [
            {id: 1, title: 'Clickstream Analytics',
                content: 'Windowing and aggregating user click events for a real-time dashboard',
                slug:'beam-clickstream-analytics',
                image: '/images/distributed/beam-landing/clickstream-analytics.svg',
                enabled: false},
            {id: 2, title: 'Fraud Detection Pipeline',
                content: 'Joining transaction streams to flag suspicious activity in real time',
                slug:'beam-fraud-detection',
                image: '/images/distributed/beam-landing/fraud-detection.svg',
                enabled: false}

        ];

        this.regressionBasics = [
            {id: 1, title: 'What is a regression problem',
                content: 'Installing ML.NET and VSCode interactive',
                slug:'basic-regression',
                image: '/images/beam/panel-default-image.svg'},
            {id: 2, title: 'Hello Regression',
                content: 'Training a simple ML.NET Regression model',
                slug:'basic-regression-problem',
                image: '/images/beam/panel-regression.svg'},
            {id: 3, title: 'What is a regression problem',
                content: 'Installing ML.NET and VSCode interactive',
                slug:'basic-regression',
                image: '/images/beam/panel-default-image.svg'},
            {id: 4, title: 'Hello Regression',
                content: 'Training a simple ML.NET Regression model',
                slug:'basic-regression-problem',
                image: '/images/beam/panel-regression.svg'},

        ];
    }

    render(){

        return (
            <React.Fragment>
                <div className="relative space-y-4 flex flex-col md:grid md:space-y-0 w-full md:grid-cols-12 2xl:grid-cols-12 md:flex-1 md:grid-rows-full rounded-2xl overflow-hidden">
                    <LandingSidebar title="Apache Beam" links={beamSidebarLinks}/>
                    <section className="pt-2 border-gray-200 md:col-span-10 lg:col-span-10 2xl:col-span-10">
                <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                    <div className="w-full px-4">
                        <div className="flex items-center mb-8">
                            <svg className="text-red-400 text-2xl mr-3 flex-none" xmlns="http://www.w3.org/2000/svg"
                                     aria-hidden="true" focusable="false"
                                     role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet"
                                     viewBox="0 0 24 24">
                                    <path className="uim-quaternary"
                                          d="M20.23 7.24L12 12L3.77 7.24a1.98 1.98 0 0 1 .7-.71L11 2.76c.62-.35 1.38-.35 2 0l6.53 3.77c.29.173.531.418.7.71z"
                                          opacity=".25" fill="currentColor" />
                                    <path className="uim-tertiary"
                                          d="M12 12v9.5a2.09 2.09 0 0 1-.91-.21L4.5 17.48a2.003 2.003 0 0 1-1-1.73v-7.5a2.06 2.06 0 0 1 .27-1.01L12 12z"
                                          opacity=".5" fill="currentColor" />
                                    <path className="uim-primary"
                                          d="M20.5 8.25v7.5a2.003 2.003 0 0 1-1 1.73l-6.62 3.82c-.275.13-.576.198-.88.2V12l8.23-4.76c.175.308.268.656.27 1.01z"
                                          fill="currentColor" />
                                </svg>
                            <h2 className="text-2xl font-semibold leading-tight text-blue-800">Beam Concepts</h2>
                        </div>
                        <div className="grid lg:grid-cols-3 gap-4">
                            {this.beamConcepts.map((data) => (
                                <LandingPanel title={data.title} imageSource={data.image} to={"/distributed-computing/apache-beam/concepts/" + data.slug} strapLine={data.content} enabled={data.enabled}  />
                            ))}
                        </div>
                    </div>
                </div>

                <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                    <div className="w-full px-4">
                        <div className="flex items-center mb-8">
                            <svg className="text-blue-400 text-2xl mr-3 flex-none" xmlns="http://www.w3.org/2000/svg"
                                     aria-hidden="true" focusable="false"
                                     role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet"
                                     viewBox="0 0 24 24">
                                    <path className="uim-quaternary"
                                          d="M20.23 7.24L12 12L3.77 7.24a1.98 1.98 0 0 1 .7-.71L11 2.76c.62-.35 1.38-.35 2 0l6.53 3.77c.29.173.531.418.7.71z"
                                          opacity=".25" fill="currentColor"></path>
                                    <path className="uim-tertiary"
                                          d="M12 12v9.5a2.09 2.09 0 0 1-.91-.21L4.5 17.48a2.003 2.003 0 0 1-1-1.73v-7.5a2.06 2.06 0 0 1 .27-1.01L12 12z"
                                          opacity=".5" fill="currentColor"></path>
                                    <path className="uim-primary"
                                          d="M20.5 8.25v7.5a2.003 2.003 0 0 1-1 1.73l-6.62 3.82c-.275.13-.576.198-.88.2V12l8.23-4.76c.175.308.268.656.27 1.01z"
                                          fill="currentColor"></path>
                                </svg>
                            <h2 className="text-2xl font-semibold leading-tight text-blue-800">Simple Examples</h2>
                        </div>
                        <div className="grid lg:grid-cols-3 gap-4">
                            {this.beamSimpleExamples.map((data) => (
                                <LandingPanel title={data.title} imageSource={data.image} to={"/distributed-computing/apache-beam/examples/" + data.slug} strapLine={data.content} enabled={data.enabled}  />
                            ))}
                        </div>
                    </div>
                </div>


                <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                    <div className="w-full px-4">
                        <div className="flex items-center mb-8">
                            <svg className="text-green-400 text-2xl mr-3 flex-none" xmlns="http://www.w3.org/2000/svg"
                                     aria-hidden="true" focusable="false"
                                     role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet"
                                     viewBox="0 0 24 24">
                                    <path className="uim-quaternary"
                                          d="M20.23 7.24L12 12L3.77 7.24a1.98 1.98 0 0 1 .7-.71L11 2.76c.62-.35 1.38-.35 2 0l6.53 3.77c.29.173.531.418.7.71z"
                                          opacity=".25" fill="currentColor"></path>
                                    <path className="uim-tertiary"
                                          d="M12 12v9.5a2.09 2.09 0 0 1-.91-.21L4.5 17.48a2.003 2.003 0 0 1-1-1.73v-7.5a2.06 2.06 0 0 1 .27-1.01L12 12z"
                                          opacity=".5" fill="currentColor"></path>
                                    <path className="uim-primary"
                                          d="M20.5 8.25v7.5a2.003 2.003 0 0 1-1 1.73l-6.62 3.82c-.275.13-.576.198-.88.2V12l8.23-4.76c.175.308.268.656.27 1.01z"
                                          fill="currentColor"></path>
                                </svg>
                            <h2 className="text-2xl font-semibold leading-tight text-blue-800">Advanced Examples</h2>
                        </div>
                        <div className="grid lg:grid-cols-3 gap-4">
                            {this.tutorials.map((data) => (
                                <LandingPanel title={data.title} imageSource={data.image} to={"/distributed-computing/apache-beam/tutorials/" + data.slug} strapLine={data.content} enabled={data.enabled}  />
                            ))}
                        </div>
                    </div>
                </div>
                    </section>
                </div>
            </React.Fragment>
        )
    };

}

export default BeamLanding;